'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  ', '\n'], ['\n  display: flex;\n  ', '\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCreateComponentFromTagProp = require('react-create-component-from-tag-prop');

var _reactCreateComponentFromTagProp2 = _interopRequireDefault(_reactCreateComponentFromTagProp);

var _grid = require('../mixins/grid');

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridComponent = (0, _reactCreateComponentFromTagProp2.default)({
  tag: 'div',
  prop: 'component',
  propsToOmit: ['halign', 'valign', 'wrap', 'reverse', 'horizontalAlign', 'verticalAlign']
});

var Grid = (0, _styledComponents2.default)(GridComponent)(_templateObject, _grid2.default);

Grid.propTypes = {
  halign: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['left', 'right', 'center', 'justify-center', 'justify']), _propTypes2.default.object]),
  valign: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['top', 'bottom', 'center', 'stretch']), _propTypes2.default.object]),
  wrap: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  reverse: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  horizontalAlign: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['left', 'right', 'center', 'justify-center', 'justify']), _propTypes2.default.object]),
  verticalAlign: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['top', 'bottom', 'center', 'stretch']), _propTypes2.default.object])
};

exports.default = Grid;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-grid/dist/cjs/components/Grid.js
// module id = 1023
// module chunks = 95715928098905 168707334958949